import type { SportsApi } from "@/v2/api/metadata/sports";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import {
  sportDefaultEventSelectionOptions,
  sportGamesStatusOptions,
  sportPositionValidator,
} from "../../../../shared";
import { notifySuccess, sportId } from "../shared";

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: sportGamesStatusOptions,
        inheritance: {
          computedKey: "computedStatus",
          parentKey: "parentStatus",
        },
      },
      {
        type: "text-field",
        name: "position",
        label: "Position",
        placeholder: "Enter position",
        validate: sportPositionValidator,
        inheritance: {
          computedKey: "computedPosition",
          parentKey: "parentPosition",
        },
      },
      {
        type: "structured-array-field",
        name: "displayIds",
        label: "Display IDs",
        minItems: 0,
        maxItems: 50,
        inheritance: {
          computedKey: "computedDisplayIds",
          parentKey: "parentDisplayIds",
        },
        children: [
          {
            type: "text-field",
            name: "prefix",
            label: "",
            placeholder: "Prefix",
            flex: 1,
          },
          {
            type: "text-field",
            name: "rangeFrom",
            label: "",
            placeholder: "From",
            inputType: "number",
            flex: 1,
          },
          {
            type: "text-field",
            name: "rangeTo",
            label: "",
            placeholder: "To",
            inputType: "number",
            flex: 1,
          },
        ],
      },
      {
        type: "select-field",
        name: "defaultEventSelection",
        label: "Default Event Selection",
        placeholder: "Select default event selection for pre-match game",
        options: sportDefaultEventSelectionOptions,
        inheritance: {
          computedKey: "defaultEventSelection",
          parentKey: "parentDefaultEventSelection",
        },
      },
    ],
  },
];

export function createPrematchTab(sportsApi: SportsApi): ContentTab {
  const save = createInheritableTabSave({
    children: prematchTabChildren,
    persist: async (patch, ctx: DialogTabSaveContext) => {
      await sportsApi.update(sportId(ctx.values), patch);
      notifySuccess();
    },
  });

  return {
    id: "prematch",
    label: "Prematch",
    save,
    children: prematchTabChildren,
  };
}
